import type { Board, CouponId, CouponIndex } from '../../../../../schema/coupon/entry.js';
import type { CouponState } from '../../../../domain/entry.js';
import { selectCoupon } from './selectCoupon.js';

type QueryOptionsType = {
  boardIndex: number;
  couponIndex: CouponIndex;
};

/**
 * Selects a given coupon board from the state.
 *
 * @param couponId Coupon id to select
 * @param root0 Object containing query options
 * @param root0.boardIndex Board index if multiple boards, normally this should be 0
 * @param root0.couponIndex Index for coupon
 * @returns Coupon board entity
 */
export function selectCouponBoard(couponId: CouponId, { boardIndex, couponIndex }: QueryOptionsType) {
  return (state: CouponState): Board | undefined => {
    const coupon = selectCoupon(couponId, { couponIndex })(state);

    return coupon?.boards[boardIndex];
  };
}
